function isMediaPlaying(media) {
  return media && !media.paused && !media.ended && media.playbackRate !== 0 && media.readyState !== 0;
}
function getVideoPlaybackQuality(video) {
  if (!video)
    return {};
  if (typeof video.getVideoPlaybackQuality === "function") {
    var info = video.getVideoPlaybackQuality();
    return {
      droppedVideoFrames: info.droppedVideoFrames || info.corruptedVideoFrames,
      totalVideoFrames: info.totalVideoFrames,
      creationTime: info.creationTime
    };
  }
  return {
    droppedVideoFrames: video.webkitDroppedFrameCount,
    totalVideoFrames: video.webkitDecodedFrameCount,
    creationTime: performance.now()
  };
}
function concatUint8Array() {
  for (var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++) {
    arr[_key] = arguments[_key];
  }
  arr = arr.filter(Boolean);
  if (arr.length < 2)
    return arr[0];
  var data = new Uint8Array(arr.reduce(function(p, c) {
    return p + c.byteLength;
  }, 0));
  var prevLen = 0;
  arr.forEach(function(d) {
    data.set(d, prevLen);
    prevLen += d.byteLength;
  });
  return data;
}
function sleep() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  return new Promise(function(resolve) {
    return setTimeout(resolve, t);
  });
}
export { concatUint8Array, getVideoPlaybackQuality, isMediaPlaying, sleep };
